export const connectTrustWallet = async () => {
  try {
    if (!window.ethereum || !window.ethereum.isTrust) {
      window.location.href =
        "https://link.trustwallet.com/open_url?url=http://localhost:3000";
      return;
    }

    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    return accounts.length > 0 ? accounts[0] : null;
  } catch (error) {
    console.error("Trust Wallet connection failed:", error);
  }
};

export const disconnectTrustWallet = async () => {
  try {
    if (window.ethereum && window.ethereum.isTrust) {
      await window.ethereum.request({
        method: "wallet_requestPermissions",
        params: [{ eth_accounts: {} }],
      });
    }
  } catch (error) {
    console.error("Error disconnecting Trust Wallet:", error);
  }
};
